import moment from 'moment'
import { mapState, mapGetters, mapActions } from 'vuex'
import lang from '../lang'

function convertObjectToArray(obj) {
  let result = []

  Object.keys(obj).forEach(key => {
    const parts = key.split('-')
    let appKey = parts[0]
    let moduleKey = parts[1] || null
    let submoduleKey = parts[2] || null

    let appId = parseInt(appKey.replace('appid', ''), 10)
    let moduleId = moduleKey ? parseInt(moduleKey.replace('moduleid', ''), 10) : null
    let submoduleId = submoduleKey ? parseInt(submoduleKey.replace('submoduleid', ''), 10) : null

    let app = result.find(item => item.appId === appId)
    if (!app) {
      app = {
        appId: appId,
        appKey: appKey,
        appName: obj[key],
        modules: [],
      }
      result.push(app)
    }

    if (moduleKey) {
      let module = app.modules.find(m => m.moduleId === moduleId)
      if (!module) {
        module = {
          moduleId: moduleId,
          moduleKey: moduleKey,
          moduleName: obj[key],
          submodules: [],
        }
        app.modules.push(module)
      }

      if (submoduleKey) {
        let submodule = module.submodules.find(s => s.submoduleId === submoduleId)
        if (!submodule) {
          submodule = {
            submoduleId: submoduleId,
            submoduleKey: submoduleKey,
            submoduleName: obj[key],
          }
          module.submodules.push(submodule)
        }
      }
    }
  })

  return result
}

export default {
  data () {
    return {
      packages: [
        {
          packageKey: 'pos',
          appTranslateKey: 'pos',
          appId: 1,
          supportAppIds: [2, 11, 8],
          reportModuleIds: [1, 2],
          checkAlertModalPackageAppIds: [1],
          advancedTableRows: [
            {
              item: this.$t('apps.billing.message.packageusercount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('apps.billing.message.packagebranchcount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
          ],
          addOnTableRows: [
            {
              item: this.$t('apps.billing.message.productcount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('apps.billing.message.billcount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('apps.billing.message.tablecount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            // {
            //   item: this.$t('apps.billing.message.emailcount'),
            //   detail: this.$t('apps.billing.message.unlimited'),
            // },
            // {
            //   item: this.$t('apps.billing.message.linecount'),
            //   detail: this.$t('apps.billing.message.unlimited'),
            // },
          ],
          channelTableRows: [
            {
              item: this.$t('platform_channels.line'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
          ],
        },
        {
          packageKey: 'accounting',
          appTranslateKey: 'accounts',
          appId: 12,
          supportAppIds: [5, 4, 6, 2, 11, 8], // ใช้แสดงข้อมูลใน table
          reportModuleIds: [1, 4, 5], // ใช้แสดงข้อมูลใน table ดึงเฉพาะ sub module id ที่ต้องการของ report
          checkAlertModalPackageAppIds: [4, 5, 6, 12, 14], // ใช้เช็คแสดง modal ให้อัปเกรด เมื่อเข้าใช้งานแอพเหล่านี้
          advancedTableRows: [
            {
              item: this.$t('apps.billing.message.packageusercount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
          ],
          addOnTableRows: [
            {
              item: this.$t('apps.billing.message.skucount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('apps.billing.message.accountdoccount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('apps.billing.message.automatedaccountingcount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            // {
            //   item: this.$t('apps.billing.message.emailcount'),
            //   detail: this.$t('apps.billing.message.unlimited'),
            // },
            // {
            //   item: this.$t('apps.billing.message.linecount'),
            //   detail: this.$t('apps.billing.message.unlimited'),
            // },
          ],
          channelTableRows: [
            {
              item: this.$t('platform_channels.line'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
          ],
        },
        {
          packageKey: 'inventory',
          appTranslateKey: 'inventory',
          appId: 3,
          supportAppIds: [2, 11, 8],
          reportModuleIds: [3],
          checkAlertModalPackageAppIds: [3],
          advancedTableRows: [
            {
              item: this.$t('apps.billing.message.packageusercount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('apps.billing.message.packagewarehousecount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
          ],
          addOnTableRows: [
            {
              item: this.$t('apps.billing.message.skucount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('apps.billing.message.inventorydoccount'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            // {
            //   item: this.$t('apps.billing.message.emailcount'),
            //   detail: this.$t('apps.billing.message.unlimited'),
            // },
            // {
            //   item: this.$t('apps.billing.message.linecount'),
            //   detail: this.$t('apps.billing.message.unlimited'),
            // },
          ],
          channelTableRows: [
            {
              item: this.$t('platform_channels.line'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('platform_channels.shopee'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('platform_channels.lazada'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('platform_channels.kerryexpress'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('platform_channels.flashexpress'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
            {
              item: this.$t('platform_channels.jtexpress'),
              detail: this.$t('apps.billing.message.unlimited'),
            },
          ],
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      shop: 'getShopInfo',
      getLang: 'getLang',
    }),
    mapPackages() {
      return this.packages
        .map((item) => {
          const apps = (() => {
            const supportApps = (() => {
              let results = []
              item.supportAppIds.forEach((supportAppId) => {
                const app = this.apps.find((appItem) => appItem.appId == supportAppId)
                if (app) {
                  results.push(app)
                }
              })
              return results
            })()
            return [
              this.apps.find((app) => app.appId == item.appId),
              ...supportApps,
            ].reduce((acc, cur) => {
              let modules = cur.modules
              if (cur.appId === 8) {
                modules = []
                cur.modules.forEach((module) => {
                  if (item.reportModuleIds.includes(module.moduleId)) {
                    modules.push(module)
                  }
                })
              }
              acc.push({
                ...cur,
                modules: modules,
              })
              return acc
            }, [])
          })()
          return {
            packageKey: item.packageKey,
            title: this.$t(`apps.billing.packages.title.${item.packageKey}`),
            appIcon: this.$t(`app.${item.appTranslateKey}.icon`),
            appColor: this.$t(`app.${item.appTranslateKey}.bgcolor`),
            masterPriceList: this.pricing.metadata.package[item.packageKey].price_list,
            isShow: this.pricing.metadata.package[item.packageKey].status.is_permanent != true,
            apps: apps,
            isFocus: this.recommendedPackageKeys.includes(item.packageKey),
            advancedTableRows: item.advancedTableRows,
            addOnTableRows: item.addOnTableRows,
            channelTableRows: item.channelTableRows,
            payButtonText: this.getPayButtonText(item.packageKey),
            payButtonClass: this.getPayButtonClass(item.packageKey),
          }
        })
        .filter((item) => item.isShow)
    },
    pricing() {
      return this.shop.pricing
    },
    currentPackageRows() {
      return [
        this.getCurrentPackageRow('pos'),
        this.getCurrentPackageRow('inventory'),
        this.getCurrentPackageRow('accounting'),
      ].filter((v) => v)
    },
    apps() {
      return convertObjectToArray(lang[this.getLang].apps.settings.permission)
    },
    recommendedPackageKeys() {
      return `${this.$route.query.recommended}`.split(',').filter((v) => v)
    },
  },
  methods: {
    ...mapActions({
      getShopDiscounts: 'getShopDiscounts',
    }),
    ...mapActions('billing', {
      setPurchasePackage: 'setPurchasePackage',
    }),
    handleSubmit(form) {
      const { packageKey, monthNumber, total, detail } = form
      this.setPurchasePackage({
        key: packageKey,
        month: monthNumber,
        total: total,
        detail: detail,
      })
      this.$router.push({
        name: 'PaymentPackageInvoice',
      })
    },
    getCurrentPackageRow(packageKey) {
      if (this.pricing.metadata.package[packageKey].status.is_permanent) {
        return {
          packageKey: packageKey,
          detail: this.$t(`apps.billing.packages.title.${packageKey}`),
          expiredAt: this.$t('apps.billing.message.onetimepurchase'),
          expiredAtDate: null,
          isPermanent: true,
        }
      } else if (this.pricing.metadata.package[packageKey].status.expired_at != null) {
        return {
          packageKey: packageKey,
          detail: this.$t(`apps.billing.packages.title.${packageKey}`),
          expiredAt: this.getDate(this.pricing.metadata.package[packageKey].status.expired_at),
          expiredAtDate: this.moment(this.pricing.metadata.package[packageKey].status.expired_at).toDate(),
          isPermanent: false,
        }
      } else {
        return null
      }
    },
    isAlreadyPaid(packageKey) {
      const packageInfo = this.currentPackageRows.find((item) => item.packageKey === packageKey)
      if (packageInfo && packageInfo.expiredAtDate != null) {
        return true
      }
      return false
    },
    getPayButtonText(packageKey) {
      if (this.isAlreadyPaid(packageKey)) {
        return this.$t('apps.billing.button.renewpackage')
      }
      return this.$t('apps.billing.button.purchasepackage')
    },
    getPayButtonClass(packageKey) {
      if (this.isAlreadyPaid(packageKey)) {
        return 'btn-light'
      }
      return 'btn-web'
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/package.js